import { request } from '../client';

export const getWallet = (params) => request('/wallet', { params });

export const getWalletHistory = (params) => request('/wallet/history', { params });
